// API related actions
// common
export const FETCHING_PENDING_INVOICES_TO_BIN = '@@toyota/FETCHING_PENDING_INVOICES_TO_BIN';
export const FETCHED_PENDING_INVOICES_TO_BIN = '@@toyota/FETCHED_PENDING_INVOICES_TO_BIN';
export const FETCHED_PENDING_INVOICES_TO_BIN_FAILED = '@@toyota/FETCHED_PENDING_INVOICES_TO_BIN_FAILED';
export const FETCHING_INVOICE_INFO = '@@toyota/FETCHING_INVOICE_INFO';
export const FETCHED_INVOICE_INFO = '@@toyota/FETCHED_INVOICE_INFO';
export const FETCHED_INVOICE_INFO_FAILED = '@@toyota/FETCHED_INVOICE_INFO_FAILED';
export const FETCHING_INVOICE_LINES_CHECK_STATUS = '@@toyota/FETCHING_INVOICE_LINES_CHECK_STATUS';
export const FETCHED_INVOICE_LINES_CHECK_STATUS = '@@toyota/FETCHED_INVOICE_LINES_CHECK_STATUS';
export const FETCHED_INVOICE_LINES_CHECK_STATUS_FAILED = '@@toyota/FETCHED_INVOICE_LINES_CHECK_STATUS_FAILED';
export const FETCHING_STORAGE_CARS = '@@toyota/FETCHING_STORAGE_CARS';
export const FETCHED_STORAGE_CARS = '@@toyota/FETCHED_STORAGE_CARS';
export const FETCHED_STORAGE_CARS_FAILED = '@@toyota/FETCHED_STORAGE_CARS_FAILED';
export const CHANGING_STORAGE_CAR_STATUS = '@@toyota/CHANGING_STORAGE_CAR_STATUS';
export const CHANGED_STORAGE_CAR_STATUS = '@@toyota/CHANGED_STORAGE_CAR_STATUS';
export const CHANGED_STORAGE_CAR_STATUS_FAILED = '@@toyota/CHANGED_STORAGE_CAR_STATUS_FAILED';
// checking
export const FETCHING_BOXES_LIST_BY_INVOICE = '@@toyota/FETCHING_BOXES_LIST_BY_INVOICE';
export const FETCHED_BOXES_LIST_BY_INVOICE = '@@toyota/FETCHED_BOXES_LIST_BY_INVOICE';
export const FETCHED_BOXES_LIST_BY_INVOICE_FAILED = '@@toyota/FETCHED_BOXES_LIST_BY_INVOICE_FAILED';
export const VALIDATING_BOX_BELONG_INVOICE = '@@toyota/VALIDATING_BOX_BELONG_INVOICE';
export const VALIDATED_BOX_BELONG_INVOICE = '@@toyota/VALIDATED_BOX_BELONG_INVOICE';
export const VALIDATED_BOX_BELONG_INVOICE_FAILED = '@@toyota/VALIDATED_BOX_BELONG_INVOICE_FAILED';
export const VERIFYING_INVOICE_LINE_INFO = '@@toyota/VERIFYING_INVOICE_LINE_INFO';
export const VERIFIED_INVOICE_LINE_INFO = '@@toyota/VERIFIED_INVOICE_LINE_INFO';
export const VERIFIED_INVOICE_LINE_INFO_FAILED = '@@toyota/VERIFIED_INVOICE_LINE_INFO_FAILED';
export const SAVING_INVOICE_LINE_INFO = '@@toyota/SAVING_INVOICE_LINE_INFO';
export const SAVED_INVOICE_LINE_INFO = '@@toyota/SAVED_INVOICE_LINE_INFO';
export const SAVED_INVOICE_LINE_INFO_FAILED = '@@toyota/SAVED_INVOICE_LINE_INFO_FAILED';
export const UPDATE_FIELDS_BINNING = '@@toyota/UPDATE_FIELDS_BINNING';

// verify invoice
export const VERIFYING_INVOICE = '@@toyota/VERIFYING_INVOICE';
export const VERIFIED_INVOICE = '@@toyota/VERIFIED_INVOICE';
export const VERIFIED_INVOICE_FAILED = '@@toyota/VERIFIED_INVOICE_FAILED';
// verify box
export const VERIFYING_BOX = '@@toyota/VERIFYING_BOX';
export const VERIFIED_BOX = '@@toyota/VERIFIED_BOX';
export const VERIFIED_BOX_FAILED = '@@toyota/VERIFIED_BOX_FAILED';
// storage page
export const CHECKING_USER_STORAGE_SESSION = '@@toyota/CHECKING_USER_STORAGE_SESSION';
export const CHECKED_USER_STORAGE_SESSION = '@@toyota/CHECKED_USER_STORAGE_SESSION';
export const CHECKED_USER_STORAGE_SESSION_FAILED = '@@toyota/CHECKED_USER_STORAGE_SESSION_FAILED';
export const FETCHING_PENDING_LINES_TO_STORAGE_BY_CAR = '@@toyota/FETCHING_PENDING_LINES_TO_STORAGE_BY_CAR';
export const FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR = '@@toyota/FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR';
export const FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR_FAILED = '@@toyota/FETCHED_PENDING_LINES_TO_STORAGE_BY_CAR_FAILED';
// close
export const CLOSING_INVOICE = '@@toyota/CLOSING_INVOICE';
export const CLOSED_INVOICE = '@@toyota/CLOSED_INVOICE';
export const CLOSED_INVOICE_FAILED = '@@toyota/CLOSED_INVOICE_FAILED';
// labels reprint
export const FECTHING_LABELS_BY_INVOICE = '@@toyota/FECTHING_LABELS_BY_INVOICE';
export const FECTHED_LABELS_BY_INVOICE = '@@toyota/FECTHED_LABELS_BY_INVOICE';
export const FECTHED_LABELS_BY_INVOICE_FAILED = '@@toyota/FECTHED_LABELS_BY_INVOICE_FAILED';

// internals orders
export const FETCHING_INTERNALS_ORDERS_LIST = '@@toyota/FETCHING_INTERNALS_ORDERS_LIST';
export const FETCHED_INTERNALS_ORDERS_LIST = '@@toyota/FETCHED_INTERNALS_ORDERS_LIST';
export const FETCHED_INTERNALS_ORDERS_LIST_FAILED = '@@toyota/FETCHED_INTERNALS_ORDERS_LIST_FAILED';
export const CREATING_INTERNAL_ORDER = '@@toyota/CREATING_INTERNAL_ORDER';
export const CREATED_INTERNAL_ORDER = '@@toyota/CREATED_INTERNAL_ORDER';
export const CREATED_INTERNAL_ORDER_FAILED = '@@toyota/CREATED_INTERNAL_ORDER_FAILED';
export const DELETING_INTERNAL_ORDER = '@@toyota/DELETING_INTERNAL_ORDER';
export const DELETED_INTERNAL_ORDER = '@@toyota/DELETED_INTERNAL_ORDER';
export const DELETED_INTERNAL_ORDER_FAILED = '@@toyota/DELETED_INTERNAL_ORDER_FAILED';
export const FETCHING_INTERNAL_ORDER = '@@toyota/FETCHING_INTERNAL_ORDER';
export const FETCHED_INTERNAL_ORDER = '@@toyota/FETCHED_INTERNAL_ORDER';
export const FETCHED_INTERNAL_ORDER_FAILED = '@@toyota/FETCHED_INTERNAL_ORDER_FAILED';
export const VERIFYING_STOCK_IN_WAREHOUSE = '@@toyota/VERIFYING_STOCK_IN_WAREHOUSE';
export const VERIFIED_STOCK_IN_WAREHOUSE = '@@toyota/VERIFIED_STOCK_IN_WAREHOUSE';
export const VERIFIED_STOCK_IN_WAREHOUSE_FAILED = '@@toyota/VERIFIED_STOCK_IN_WAREHOUSE_FAILED';
export const ADDING_ITEM_TO_INTERNAL_ORDER = '@@toyota/ADDING_ITEM_TO_INTERNAL_ORDER';
export const ADDED_ITEM_TO_INTERNAL_ORDER = '@@toyota/ADDED_ITEM_TO_INTERNAL_ORDER';
export const ADDED_ITEM_TO_INTERNAL_ORDER_FAILED = '@@toyota/ADDED_ITEM_TO_INTERNAL_ORDER_FAILED';
export const DELETING_ITEM_FROM_INTERNAL_ORDER = '@@toyota/DELETING_ITEM_FROM_INTERNAL_ORDER';
export const DELETED_ITEM_FROM_INTERNAL_ORDER = '@@toyota/DELETED_ITEM_FROM_INTERNAL_ORDER';
export const DELETED_ITEM_FROM_INTERNAL_ORDER_FAILED = '@@toyota/DELETED_ITEM_FROM_INTERNAL_ORDER_FAILED';
export const UPDATE_ITEM_VALUE_FROM_INTERNAL_ORDER = '@@toyota/UPDATE_ITEM_VALUE_FROM_INTERNAL_ORDER';

// invoicing
export const FETCHING_MANUAL_INVOICE_DATA = '@@toyota/FETCHING_MANUAL_INVOICE_DATA';
export const FETCHED_MANUAL_INVOICE_DATA = '@@toyota/FETCHED_MANUAL_INVOICE_DATA';
export const FETCHED_MANUAL_INVOICE_DATA_FAILED = '@@toyota/FETCHED_MANUAL_INVOICE_DATA_FAILED';
export const ADDING_ITEM_TO_MANUAL_ORDER = '@@toyota/ADDING_ITEM_TO_MANUAL_ORDER';
export const ADDED_ITEM_TO_MANUAL_ORDER = '@@toyota/ADDED_ITEM_TO_MANUAL_ORDER';
export const ADDED_ITEM_TO_MANUAL_ORDER_FAILED = '@@toyota/ADDED_ITEM_TO_MANUAL_ORDER_FAILED';
export const DELETING_ITEM_FROM_MANUAL_ORDER = '@@toyota/DELETING_ITEM_FROM_MANUAL_ORDER';
export const DELETED_ITEM_FROM_MANUAL_ORDER = '@@toyota/DELETED_ITEM_FROM_MANUAL_ORDER';
export const DELETED_ITEM_FROM_MANUAL_ORDER_FAILED = '@@toyota/DELETED_ITEM_FROM_MANUAL_ORDER_FAILED';
export const SAVING_INVOICE = '@@toyota/SAVING_INVOICE';
export const SAVED_INVOICE = '@@toyota/SAVED_INVOICE';
export const SAVED_INVOICE_FAILED = '@@toyota/SAVED_INVOICE_FAILED';

// complementary actions
// common
export const EMPTY_INFO = '@@toyota/EMPTY_INFO';
// checking
export const CLEAR_ITEMS = '@@toyota/CLEAR_ITEMS';
export const SET_LAST_CHECKED_BOX = '@@toyota/SET_LAST_CHECKED_BOX';
export const SUCCESS_BOX_MEMBERSHIP_CHECK = '@@toyota/SUCCESS_BOX_MEMBERSHIP_CHECK';
export const STORAGE_CAR_STILL_AVAILABLE = '@@toyota/STORAGE_CAR_STILL_AVAILABLE';
// verify invoice
export const CHANGE_VERIFY_INVOICE_LIST_PAGE = '@@toyota/CHANGE_VERIFY_INVOICE_LIST_PAGE';
export const CHANGE_VERIFY_INVOICE_LIST_PAGE_SIZE = '@@toyota/CHANGE_VERIFY_INVOICE_LIST_PAGE_SIZE';
// labels reprint
export const CHANGE_LABELS_LIST_PAGE = '@@toyota/CHANGE_LABELS_LIST_PAGE';
export const CHANGE_LABELS_LIST_PAGE_SIZE = '@@toyota/CHANGE_LABELS_LIST_PAGE_SIZE';
export const EMPTY_LABELS = '@@toyota/EMPTY_LABELS';

// internals orders
export const CHANGE_INTERNALS_ORDERS_LIST_PAGE = '@@CHANGE_INTERNALS_ORDERS_LIST_PAGE/EMPTY_LABELS';
export const CHANGE_INTERNALS_ORDERS_LIST_PAGE_SIZE = '@@toyota/CHANGE_INTERNALS_ORDERS_LIST_PAGE_SIZE';
export const EMPTY_ORDERS_DATA = '@@toyota/EMPTY_ORDERS_DATA';
export const CLEAR_INTERNAL_ORDER_FORM = '@@toyota/CLEAR_INTERNAL_ORDER_FORM';
export const UPDATE_SUBTOTAL = '@@toyota/UPDATE_SUBTOTAL';

// invoicing
export const ADD_ORDER_CODE_TO_INVOICE = '@@toyota/ADD_ORDER_CODE_TO_INVOICE';
export const REMOVE_ORDER_CODE_TO_INVOICE = '@@toyota/REMOVE_ORDER_CODE_TO_INVOICE';
